<template>
  <a class="default-logo"
     @click="onLogoClick">
    <img v-if="img && img.value"
         :src="img.value" />
    <img v-else
         :src="defaultLogo" />
  </a>
</template>

<script setup lang="ts">
// 基于系统配置，实现的一个Logo组件注入
import type { Plugin, SysConfigService } from '@/plugins'
import { PLUGIN_SYS_CONFIG } from '@/plugins/builtin/BuiltinPluginSymbol'
import { container } from 'tsyringe'
import { useRouter } from 'vue-router'
import { useMiscStore } from '../MiscPlugin'
import defaultLogo from './assets/imgs/default_logo.png'

// 获取系统配置
const plugin = container.resolve<Plugin<unknown, SysConfigService>>(PLUGIN_SYS_CONFIG)

const img = plugin.service.value('logo')
const router = useRouter()

const options = useMiscStore()

const onLogoClick = () => {
  router.push(options.defaultLogoRedirect || '/')
}

</script>

<style scoped lang="less">
.default-logo {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  min-height: 124px;
  margin: 2px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
